/**
 * Sudoku-pencilmarks variant — barrel.
 *
 * Variants register optional renderers per game family with the shell's
 * variant selector (`variants/index.ts`). This variant currently provides:
 *   - `SudokuHub`   — the Easy/Medium/Hard picker on lined-notebook paper
 *   - `Sudoku`      — the Sudoku renderer (consumes `games/sudoku/engine.ts`)
 *   - `manifest`    — small descriptor used by the variant selector
 *
 * Other surfaces (Affirmation, Celebration, palette, motion, sound) are
 * internal to the variant.
 */

export { Hub as SudokuHub } from './Hub';
export { Sudoku } from './Sudoku';
export type { NotebookSudokuProps } from './Sudoku';

export interface VariantManifest {
  slug: string;
  title: string;
}

export const manifest: VariantManifest = {
  slug: 'sudoku-pencilmarks',
  title: 'Notebook Sudoku',
};
